(function() {
  const selectors = Object.freeze({
    addToCartBtn: '.add-to-cart-order-form',
    inputQty: '.pure-table input.quantity'
  });
  
  function addItemToCart(options) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: true,
      data: options.item,
      dataType: 'json',
      error: function(err) {
        console.log(err);
      },
      success: function(data) {
        options.complete();
      },
      cache: false
    });        
  }
  
  $(function() {
    // Add to cart event
    $(document).on('click', selectors.addToCartBtn, function(e) {
      e.preventDefault();
      var items = [];
      
      // get all items
      $(selectors.inputQty).each(function() {
        if ($(this).val() > 0) {  
          items.push({
            id: $(this).data('id'),
            quantity: $(this).val(),
            properties: {
              'Sphere': $(this).data('sphere'),
              'Cylinder': $(this).data('cylinder')
            }
          });
          
          // Show Animating icon
          $(selectors.addToCartBtn).parent().find('.fa-spinner').css({'opacity': '1'});
        }
      });
            
      // Now add to cart
      async.eachSeries(items, function(item, callback) {
        addItemToCart({
          item: item,
          complete: function() {
            callback(null)
          }
        });
      }, function(err) {
        if (err) {
          console.log(err);
        }
        
        console.log('All items added!');
        // redirect to cart
        location.href = '/cart';
      });
    });
  });
})();

$(document).ready(function() {
    $('.hovhigh').on('mouseover', function() {
        $(this).closest('table').find('.hovhigh:nth-child(' + ($(this).index() + 1) + ')').addClass('hoveron');
    });
    $('.hovhigh').on('mouseout', function() {
        $(this).closest('table').find('.hovhigh:nth-child(' + ($(this).index() + 1) + ')').removeClass('hoveron');
    });
});